import { APP_NAME } from 'config/constants/api.constants';
import { SeoLinkType, SeoOpenGraphType } from 'config/types/common.type';
import React from 'react';
import { Helmet } from 'react-helmet';

type SeoProps = {
  title: string;
  charset?: string;
  openGraphTags?: SeoOpenGraphType[];
  linkTags?: SeoLinkType[];
};

const Seo: React.FC<SeoProps> = ({ title, charset, openGraphTags, linkTags }) => {
  const renderCharset = (charset: string): React.ReactNode => <meta charSet={charset} />;

  const renderOpenGraphTags = (openGraphTags: SeoOpenGraphType[]): React.ReactNode[] =>
    openGraphTags.map((item, index) => <meta property={`og:${item.property}`} content={item.content} key={index} />);

  const renderLinkTags = (linkTags: SeoLinkType[]): React.ReactNode[] =>
    linkTags.map((item, index) => <link rel={item.rel} type={item.type} href={item.href} key={index} />);

  return (
    <Helmet>
      <title>
        {title} | {APP_NAME}
      </title>
      <meta property='og:type' content='website' />
      {charset && renderCharset(charset)}
      {openGraphTags && openGraphTags.length > 0 && renderOpenGraphTags(openGraphTags)}
      {linkTags && linkTags.length > 0 && renderLinkTags(linkTags)}
    </Helmet>
  );
};

export default Seo;
